import React from 'react';

class Startup extends React.Component {
    constructor(props) {
        super(props);
        
        setTimeout(()=>{ this.props.history.push('/login')  },1000)
    }
    render(){
        
        return(
            <div>Bezig met laden</div>
        )
    }
}
export default Startup;